import {createTableState} from '@/core/services/Helper'

const state = () => ({
    table: createTableState(),
})

const getters = {}

const actions = {
    async get({state, commit, rootState}, {filterData} = {}) {
        const selectedCompany = rootState.company.authorized.selectCompany
        if (!selectedCompany) return

        commit('setLoading', true)

        let params = {
            page_limit: 9999,
        }

        if (filterData) {
            params = {...params, ...filterData}
        }

        try {
            const res = await this._vm.axios.get(
                this._vm.endpoints['company_officer'],
                {params}
            )
            const {data} = res.data
            commit('updateTableData', data || [])
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        } finally {
            commit('setLoading', false)
        }
    },
}

const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updateTableData(state, data) {
        state.table.data = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
